<template>
  <div class="calendar">
    <!-- 年份 月份 -->
    <div class="month">
      <ul>
        <!--点击会触发pickpre函数，重新刷新当前日期 @click(vue v-on:click缩写) -->
        <li class="arrow" @click="pickPre(currentYear, currentMonth)">❮</li>
        <li class="year-month">{{ currentYear }}年{{ currentMonth }}月</li>
        <li class="arrow" @click="pickNext(currentYear, currentMonth)">❯</li>
      </ul>
    </div>
    <!-- 星期 -->
    <ul class="weekdays">
      <li>周一</li>
      <li>周二</li>
      <li>周三</li>
      <li>周四</li>
      <li>周五</li>
      <li style="color:red">周六</li>
      <li style="color:red">周日</li>
    </ul>
    <!-- 日期 -->
    <ul class="days">
      <!-- 核心 v-for循环 每一次循环用<li>标签创建一天 -->
      <li v-for="(dayobject, index) in days" :key="index">
        <div :class="dayobject.isGainsboro ? 'gainsboro' : ''">
          <div
            class="date"
            :class="
              dayobject.day.getMonth() + 1 === nowMonth &&
              dayobject.day.getDate() === nowDate
                ? 'today'
                : ''
            "
          >
            {{ dayobject.day.getDate() }}
          </div>
          <div v-if="dayobject.isSign === true" class="sign">
            <van-icon name="checked" color="#48c774" />
          </div>
          <div v-else-if="dayobject.integral > 0" class="sign">
            <span class="rewards">+{{ dayobject.integral }}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { add } from "@utils/bc";

export default {
  name: "CalendarSignIn",
  props: {
    config: {
      type: Array,
      default: () => []
    },
    signNum: {
      type: Number,
      default: 0
    },
    isDaySign: {
      type: Boolean,
      default: false
    },
    rewardType: {
      type: String,
      default: "continuous"
    }
  },
  data: function() {
    return {
      currentDay: 1,
      currentMonth: 1,
      currentYear: 1970,
      currentWeek: 1,
      nowMonth: 1,
      nowDate: 1,
      days: [],
      arrDate: [],
      monthIndex: 0,
      today: new Date().getTime()
    };
  },
  mounted: function() {
    // var date = new Date();
    // this.nowMonth = date.getMonth() + 1;
    // this.nowDate = date.getDate();
    // this.signList.forEach((item) => {
    //  this.arrDate.push(item.addTime);
    // })
    //在vue初始化时调用
    var date = new Date();
    this.nowMonth = date.getMonth() + 1;
    this.nowDate = date.getDate();
    this.today = new Date(
      this.formatDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
    ).getTime();
    this.initData(null);
  },
  methods: {
    createData(signList) {
      var date = new Date();
      this.nowMonth = date.getMonth() + 1;
      this.nowDate = date.getDate();
      this.today = new Date(
        this.formatDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
      ).getTime();
      signList.forEach(item => {
        this.arrDate.push(item.addTime);
      });
      //在vue初始化时调用
      this.initData(null);
    },
    initData: function(cur) {
      var leftcount = 0; //存放剩余数量
      var now = new Date();
      var date;
      if (cur) {
        date = new Date(cur);
      } else {
        // var d = new Date(this.formatDate(now.getFullYear(), now.getMonth(), 1));
        // d.setDate(42);
        date = new Date(
          this.formatDate(now.getFullYear(), now.getMonth() + 1, 1)
        );
      }
      this.currentDay = date.getDate();
      this.currentYear = date.getFullYear();
      this.currentMonth = date.getMonth() + 1;

      this.currentWeek = date.getDay(); // 1...6,0
      if (this.currentWeek == 0) {
        this.currentWeek = 7;
      }
      var str = this.formatDate(
        this.currentYear,
        this.currentMonth,
        this.currentDay
      );
      this.days.length = 0;
      var dayobject = {}; //用一个对象包装Date对象  以便为以后预定功能添加属性
      var d = new Date(str);
      //当前月第一天是周日，放在第一行第7个位置，前面6个
      //初始化第一周
      for (var i = this.currentWeek - 1; i >= 0; i--) {
        d = new Date(str);
        d.setDate(d.getDate() - i);
        dayobject = {
          day: d,
          isSign: this.isVerDate(
            this.formatDate(d.getFullYear(), d.getMonth() + 1, d.getDate())
          ),
          isGainsboro:
            this.monthIndex !== 0 ||
            d.getMonth() + 1 !== this.nowMonth ||
            d.getDate() < this.nowDate,
          integral: this.getIntegral(d)
        };
        this.days.push(dayobject); //将日期放入data 中的days数组 供页面渲染使用
      }
      //其他周
      for (var j = 1; j <= 42 - this.currentWeek; j++) {
        d = new Date(str);
        d.setDate(d.getDate() + j);
        //判断时间是否是当前月
        if (d.getMonth() + 1 !== this.currentMonth) {
          if (d.getDay() === 1) {
            //判断时间是否是星期一，是：那本日期及后面的日期就不用显示
            break;
          }
        }
        dayobject = {
          day: d,
          isSign: this.isVerDate(
            this.formatDate(d.getFullYear(), d.getMonth() + 1, d.getDate())
          ),
          isGainsboro:
            this.monthIndex !== 0 ||
            d.getMonth() + 1 !== this.nowMonth ||
            d.getDate() < this.nowDate,
          integral: this.getIntegral(d)
        };
        this.days.push(dayobject);
      }
    },
    isVerDate(v) {
      return this.arrDate.includes(v);
    },
    pickPre: function(year, month) {
      // setDate(0); 上月最后一天
      // setDate(-1); 上月倒数第二天
      // setDate(dx) 参数dx为 上月最后一天的前后dx天
      if (this.monthIndex <= -2) {
        return this.$dialog.toast({ mes: "目前只支持查看前两个月哦!" });
      }
      this.monthIndex--;
      var d = new Date(this.formatDate(year, month, 1));
      d.setDate(0);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    pickNext: function(year, month) {
      if (this.monthIndex >= 2) {
        return this.$dialog.toast({ mes: "目前只支持查看后两个月哦!" });
      }
      this.monthIndex++;
      var d = new Date(this.formatDate(year, month, 1));
      d.setDate(42);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    // 返回 类似 2016-01-02 格式的字符串
    formatDate: function(year, month, day) {
      var y = year;
      var m = month;
      if (m < 10) m = "0" + m;
      var d = day;
      if (d < 10) d = "0" + d;
      return y + "-" + m + "-" + d;
    },
    //获取奖励橙币
    getIntegral(date) {
      if (date.getTime() < this.today) {
        return 0;
      } else {
        if (this.config.length) {
          if (this.rewardType === "calendar") {
            if (this.config.length < date.getDate()) {
              return this.config[this.config.length - 1].sign_num;
            } else {
              return this.config[date.getDate() - 1].sign_num;
            }
          } else {
            let day = add(
              (date.getTime() - this.today) / (24 * 60 * 60 * 1000),
              this.signNum - (this.isDaySign ? 1 : 0)
            );
            if (day >= this.config.length) {
              let index =
                this.rewardType === "continuous"
                  ? this.config.length - 1
                  : day % this.config.length;
              return this.config[index].sign_num;
            } else {
              return this.config[day].sign_num;
            }
          }
        } else {
          return 0;
        }
      }
    }
  }
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

ul {
  list-style-type: none;
}

body {
  font-family: Verdana, sans-serif;
  background: #e8f0f3;
}
.calendar {
  width: 100%;
  margin: 0 auto;
  /* box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.1), 0 1px 5px 0 rgba(0, 0, 0, 0.12); */
  background: #fff !important;
  border: 1px solid rgba(238, 238, 238, 1);
}
.month {
  width: 100%;
  /* background: #00b8ec; */
}

.month ul {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
}

.year-month {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.arrow {
  padding: 20px;
}

.month ul li {
  color: #000000;
  font-size: 20px;
  text-transform: uppercase;
  letter-spacing: 3px;
}

.weekdays {
  margin: 0;
  padding: 10px 0;
  /* background-color: #00b8ec; */
  display: flex;
  flex-wrap: wrap;
  color: #000000;
  justify-content: space-around;
}

.weekdays li {
  display: inline-block;
  width: 13.6%;
  text-align: center;
  line-height: 40px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.days {
  padding: 0;
  background: #ffffff;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.days li {
  list-style-type: none;
  display: inline-block;
  width: 14.2%;
  height: 1rem;
  text-align: center;
  padding-bottom: 0.01rem;
  padding-top: 0.01rem;
  font-size: 0.32rem;
  color: #000;
}

.days li .gainsboro {
  color: gainsboro;
}

.today {
  background: #186cff;
  color: #fff;
  border-radius: 50%;
}

.date {
  width: 25px;
  height: 25px;
  line-height: 25px;
  margin: auto;
  justify-content: center;
  align-items: center;
  font-size: 0.3rem;
}

.sign {
  width: 25px;
  height: 25px;
  line-height: 25px;
  margin: auto;
  padding-top: 3px;
}

.rewards {
  font-size: 0.24rem;
  text-align: center;
  color: gainsboro;
}
</style>
